angular.module('egg.order', ['core', 'clients', 'egg.delivery', 'egg.order.integration'])
    .constant('EggOrderConst', {
        filteringActive: true,
        deliveryAndOrderDiffDays: 5
    })
    .factory('EggOrder', function ($resource) {
        return $resource('/crm/api/egg-order/:id', {}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/egg-order/table'},
            getItem: {method: 'GET', isArray: false, url: '/crm/api/egg-order/:id/item/:item'},
            getItemsGrouped: {method: 'GET', isArray: false, url: '/crm/api/egg-order/grouped/:dueDate'},
            update: {method: 'PUT'},
            updateNotStarted: {method: 'PUT', params: {'not-started': true}},
            remove: {method: 'DELETE'}
        });
    })
    .factory('EggOrderItemStockLine', function ($resource) {
        return $resource('/crm/api/egg-order/:orderId/item/:itemId/stock-lines/:id', {}, {
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            getItemsGrouped: {isArray: true, url: '/crm/api/egg-order/stock-lines-grouped'},
            saveGrouped: {method: 'POST', isArray: true, url: '/crm/api/egg-order/stock-lines-grouped'},
            removeGrouped: {method: 'DELETE', isArray: true, url: '/crm/api/egg-order/stock-lines-grouped'}
        });
    })
    .service('EggOrderReportService', function (modals) {
        this.openDialog = params => modals.open('app/egg/order/report-modal.tpl.html', 'EggOrderReportDialogController', params);
    })
    .service('EggOrderService', function ($rootScope, $cookies, modals, EggOrder, ModuleSettings) {
        this.edit = id => {
            EggOrder.get({id: id}).$promise.then(item => edit_modal(item));
        }

        this.editModal = entity => modals.open('app/egg/order/edit-modal.tpl.html', 'EggOrderDialogController', entity, {size: "lg"});
        this.editNotStartedModal = id => {
            EggOrder.get({id: id}).$promise.then(entity => modals.open('app/egg/order/edit-not-started-modal.tpl.html', 'EggOrderNotStartedDialogController', entity, {size: "lg"}));
        };
        this.addModal = params => {
            let entity = {
                id: null,
                dueDate: moment(),
                dateOfIssue: moment(),
                items: []
            };

            angular.extend(entity, params);
            return edit_modal(entity);
        };
        this.showModal = entity => {
            EggOrder.get({id: entity.id}).$promise.then(item => modals.open('app/egg/order/show-modal.tpl.html', 'EggOrderShowController', item, {size: "lg"}));
        };
        this.remove = function (item) {
            return modals.confirmDelete(item.number, () => EggOrder.delete({id: item.id}, () => $rootScope.$broadcast('egg.order.updated')).$promise);
        };
        this.clone = function (id) {
            let that = this;
            let entity = {};
            EggOrder.get({id: id}, order => {
                entity.id = null;
                entity.client = order.client;
                entity.deliveryAddress = order.deliveryAddress;
                entity.description = order.description;
                entity.items = [];
                angular.forEach(order.items, item => {
                    let it = {
                        id: null,
                        product: item.product,
                        quantity: item.quantity,
                        unit: item.unit
                    };
                    entity.items.push(it);
                });
                return that.addModal(entity);
            });
        };
        this.groupLinkWithDelivery = (dueDate, client, product, unit) => {
            EggOrder.getItemsGrouped({
                dueDate: dueDate,
                client: client.id,
                product: product.id,
                unit: unit.id
            }).$promise.then(item => {
                let groupInfo = {
                    dueDate: dueDate,
                    client: client,
                    product: product,
                    unit: unit
                };
                return modals.open('app/egg/order/link-with-delivery-grouped-modal.tpl.html', 'EggOrderLinkWithDeliveryGroupedController', {
                    item: item,
                    groupInfo: groupInfo
                }, {size: "lg"});
            });
        };
        this.linkWithDelivery = (order, item) => {
            EggOrder.getItem({id: order.id, item: item.id}).$promise
                .then(currentItem => modals.open('app/egg/order/link-with-delivery-modal.tpl.html', 'EggOrderLinkWithDeliveryController', {
                    item: currentItem,
                    order: order
                }, {size: "lg"}));
        };
        this.settingsModal = () => {
            ModuleSettings.get({module: "egg-order"}).$promise.then(settings => modals.open('app/egg/order/settings-modal.tpl.html', 'EggOrderSettingsController', {item: settings}, {size: 'lg'}));
        };

        function edit_modal(item) {
            return modals.open('app/egg/order/edit-modal.tpl.html', 'EggOrderDialogController', item, {size: "lg"});
        }
    })
    .controller('EggOrderListController', function ($scope, page, $state, $stateParams, Unit, EggOrderService, EggOrderReportService, EggOrderIntegrationService) {
        let vm = this;
        vm.filters = angular.copy($stateParams);
        vm.page = page;
        vm.EggOrderService = EggOrderService;
        vm.EggOrderReportService = EggOrderReportService;
        vm.EggOrderIntegrationService = EggOrderIntegrationService;
        vm.reset = () => vm.filters = {}

        vm.unitConverters = [];
        vm.onUnitConverterChanged = $item => {
            // vm.unitConverters.push($item);
        };
        vm.onUnitConverterRemoved = $item => {
            // vm.unitConverters.splice(vm.unitConverters.indexOf($item), 1);
        };

        Unit.list().$promise.then(items => vm.units = items);
        $scope.$on('egg.order.updated', () => $state.reload());
    })
    .controller('EggOrderLinkWithDeliveryController', function ($scope, $rootScope, $uibModalInstance, data, EggOrder, EggOrderItemStockLine) {

        $scope.order = data.order;
        $scope.item = data.item;
        $scope.lockSaving = false;

        loadStockLines();

        $scope.recalculate = () => {
            $scope.item.quantityLeft = Number($scope.item.stockQuantity);
            angular.forEach($scope.stockLines, line => $scope.item.quantityLeft = $scope.item.quantityLeft - line.quantity);
        };

        $scope.saveLink = $index => {
            $scope.lockSaving = true;
            let copy = angular.copy($scope.stockLines[$index]);
            copy.orderItem = $scope.item;
            return EggOrderItemStockLine
                .save(
                    {
                        orderId: $scope.order.id,
                        itemId: $scope.item.id
                    }, copy
                )
                .$promise
                .then(result => {
                    $scope.stockLines[$index] = result;
                    $scope.recalculate();
                    $rootScope.$broadcast('egg.order-link.updated');
                    $scope.lockSaving = false;
                })
                .catch(() => $scope.lockSaving = false);
        };
        $scope.deleteLink = (line, $index) => {
            $scope.lockSaving = true;
            return EggOrderItemStockLine
                .remove({
                    orderId: $scope.order.id,
                    itemId: $scope.item.id,
                    id: line.id
                }, line)
                .$promise
                .then(result => {
                    $scope.stockLines.splice($index, 1);
                    $scope.recalculate();
                    $rootScope.$broadcast('egg.order-link.updated');
                    $scope.lockSaving = false;
                })
                .catch(() => {
                    $scope.lockSaving = false;
                });
        };

        $scope.addLink = deliveryItem => {
            let quantity = Number(0);
            if ($scope.item.quantityLeft > 0 && deliveryItem.stockQuantityLeft > 0) {
                quantity = (deliveryItem.stockQuantityLeft < $scope.item.quantityLeft) ? deliveryItem.stockQuantityLeft : $scope.item.quantityLeft;
            }
            $scope.stockLines.push({
                deliveryItem: deliveryItem,
                quantity: quantity
            });
            $scope.recalculate();
        };
        $scope.cancelAddStockLine = $index => {
            $scope.stockLines.splice($index, 1);
            $scope.recalculate();
        };

        $scope.cancel = () => {
            $rootScope.$broadcast('egg.order.updated');
            $uibModalInstance.dismiss('Canceled');
        };

        function loadStockLines() {
            EggOrderItemStockLine.query({
                orderId: $scope.order.id,
                itemId: $scope.item.id
            })
                .$promise
                .then(result => $scope.stockLines = result);
        }

    })
    .controller('EggOrderLinkWithDeliveryGroupedController', function ($scope, $rootScope, $uibModalInstance, data, EggOrder, EggOrderItemStockLine) {

        $scope.item = data.item;
        $scope.groupInfo = data.groupInfo;
        $scope.lockSaving = false;

        loadStockLines();

        $scope.recalculate = () => {
            $scope.item.quantityLeftSum = Number($scope.item.stockQuantitySum);
            angular.forEach($scope.stockLines, line => $scope.item.quantityLeftSum = $scope.item.quantityLeftSum - line.quantitySum);
        };

        $scope.saveLink = $index => {
            $scope.lockSaving = true;
            let copy = angular.copy($scope.stockLines[$index]);
            copy.orderItem = $scope.item;
            return EggOrderItemStockLine.saveGrouped({
                dueDate: data.groupInfo.dueDate,
                client: data.groupInfo.client.id,
                product: data.groupInfo.product.id,
                unit: data.groupInfo.unit.id
            }, copy)
                .$promise
                .then(currentStockLines => {
                    $scope.stockLines.splice($index, 1);
                    refreshStockLines(currentStockLines);
                    $rootScope.$broadcast('egg.order-link.updated');
                    $scope.lockSaving = false;
                })
                .catch(() => $scope.lockSaving = false);
        };
        $scope.deleteLink = function (line, $index) {
            $scope.lockSaving = true;
            return EggOrderItemStockLine.removeGrouped({
                delivery: line.deliveryItem.id,
                dueDate: data.groupInfo.dueDate,
                client: data.groupInfo.client.id,
                product: data.groupInfo.product.id,
                unit: data.groupInfo.unit.id
            })
                .$promise
                .then(currentStockLines => {
                    $scope.stockLines.splice($index, 1);
                    $scope.recalculate();
                    $rootScope.$broadcast('egg.order-link.updated');
                    $scope.lockSaving = false;
                })
                .catch(() => $scope.lockSaving = false);
        };

        $scope.addLink = deliveryItem => {
            let quantity = Number(0);
            if ($scope.item.quantityLeftSum > 0 && deliveryItem.stockQuantityLeft > 0) {
                quantity = (deliveryItem.stockQuantityLeft < $scope.item.quantityLeftSum) ? deliveryItem.stockQuantityLeft : $scope.item.quantityLeftSum;
            }
            $scope.stockLines.push({
                deliveryItem: deliveryItem,
                quantitySum: quantity,
                notSaved: true
            });
            $scope.recalculate();
        };

        $scope.cancelAddStockLine = $index => {
            $scope.stockLines.splice($index, 1);
            $scope.recalculate();
        };

        $scope.cancel = () => {
            $rootScope.$broadcast('egg.order.updated');
            $uibModalInstance.dismiss('Canceled');
        };

        function refreshStockLines(currentStockLines) {
            let notSaved = $scope.stockLines.filter(line => line.notSaved);
            $scope.stockLines = currentStockLines.concat(notSaved);
            $scope.recalculate();
        }

        function loadStockLines() {
            EggOrderItemStockLine
                .getItemsGrouped({
                    dueDate: data.groupInfo.dueDate,
                    client: data.groupInfo.client.id,
                    product: data.groupInfo.product.id,
                    unit: data.groupInfo.unit.id
                })
                .$promise
                .then(result => $scope.stockLines = result);
        }
    })
    .controller('EggOrderShowController', function ($scope, $uibModalInstance, data, EggOrder, EggOrderService) {
        $scope.item = data;

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.delete = item => {
            $scope.isSaving = true;
            EggOrderService.remove(item)
                .then(() => {
                    $uibModalInstance.dismiss('Canceled');
                    $scope.isSaving = false;
                }, () => $scope.isSaving = false);
        };

        $scope.edit = item => {
            $scope.cancel();
            EggOrderService.edit(item.id);
        };
    })
    .controller('EggOrderReportDialogController', function ($scope, $uibModalInstance, data, $httpParamSerializer, Client, Product) {
        $scope.reportName = data.reportName;
        $scope.reportUrl = data.reportUrl;
        $scope.reportFilters = {
            type: 'pdf',
            tpl: '_condensed',
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().endOf('month').format("YYYY-MM-DD")
        };

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');
        $scope.refreshClients = q => Client.autocomplete({q: q}).$promise.then(items => $scope.clients = items);
        $scope.refreshProducts = q => {
            if (!$scope.productsLoading) {
                $scope.productsLoading = true;
                Product.autocomplete(q).then(items => {
                    $scope.products = items;
                    $scope.productsLoading = false;
                });
            }
        };

        $scope.parametrizedUrl = () => {
            let res = $scope.reportUrl;
            let f = $scope.reportFilters;
            let params = $httpParamSerializer(f);
            return res + "?" + params;
        }
    })
    .controller('EggOrderDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Client, ClientService, Product, ProductService, Unit, Numeration, EggOrder, ModuleSettings, EggOrderConst, EggFormsHelper) {
        $scope.ProductService = ProductService;
        $scope.EggFormsHelper = EggFormsHelper;
        $scope.EggOrderConst = EggOrderConst;
        $scope.settings = ModuleSettings.get({module: "egg-order"});
        $scope.item = data;

        $scope.addItem = () => $scope.item.items.push({quantity: 0});

        if (data.id === null) {
            Numeration.nextNumber({clazz: "pl.multisoft.modules.egg.order.EggsOrder"}).$promise.then(result => data.number = result.number);
            if ($scope.item.items.length === 0)
                $scope.addItem();
        }
        if (angular.isDefined(data.client)) {
            Client.addresses({id: data.client.id}).$promise.then(items => $scope.addresses = items)
        }

        $scope.refreshClients = q => {
            if (!$scope.clientsLoading) {
                $scope.clientsLoading = true;
                Client.autocomplete({q: q}).$promise.then(items => {
                    $scope.clients = items;
                    $scope.clientsLoading = false;
                });
            }
        };

        $scope.refreshProducts = q => {
            if (!$scope.productsLoading) {
                $scope.productsLoading = true;
                Product.autocomplete(q).then(items => {
                    $scope.products = items;
                    $scope.productsLoading = false;
                });
            }
        };

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.save = () => {
            $scope.isSaving = true;
            let toSave = angular.copy($scope.item);
            toSave.dateOfIssue = moment(toSave.dateOfIssue).format("YYYY-MM-DD");
            toSave.dueDate = moment(toSave.dueDate).format("YYYY-MM-DD");
            if ($scope.item.id !== null) {
                EggOrder.update(toSave, onSaveSuccess, onSaveError);
            } else {
                EggOrder.save(toSave, onSaveSuccess, onSaveError);
            }
        };

        var onSaveSuccess = result => {
            $rootScope.$broadcast('egg.order.updated');
            $uibModalInstance.close(result);
            $scope.isSaving = false;
            toastr.success("Zapisano");
        };

        var onSaveError = () => $scope.isSaving = false;

        $scope.addClient = () => {
            ClientService.addModal().then(client => {
                $scope.item.client = client;
                $scope.onClientChanged(client);
                $scope.refreshClients();
            });
        };

        Unit.list().$promise.then(items => $scope.units = items);

        $scope.onClientChanged = client => {
            delete $scope.item.deliveryAddress;
            if (angular.isUndefined(client)) {
                $scope.addresses = [];
                return;
            }
            $scope.loadClientAddresses(client);
        };
        $scope.loadClientAddresses = client => {
            Client.addresses({id: client.id}).$promise.then(items => {
                $scope.addresses = items
                if ($scope.item.id === null) {
                    $scope.item.deliveryAddress = items.find(i => i.defaults === true)
                }
            })
        };
        $scope.onProductChanged = (product, item) => {
            if (angular.isDefined(product)) {
                if (product.unit)
                    item.unit = product.defaultUnit;
                if (product.symbol)
                    item.product.productSymbol = product.symbol;
                if (product.name)
                    item.product.productName = $filter('localized')(product.name);

                Product.unitConverters({id: product.id}).$promise.then(unitConverters => {
                    item.product.systemProduct.unitConverters = unitConverters;
                });
            } else
                delete item.unit;

        };
    })
    .controller('EggOrderNotStartedDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Client, ClientService, Product, ProductService, Unit, Numeration, EggOrder, ModuleSettings, EggOrderConst, EggFormsHelper) {
        $scope.ProductService = ProductService;
        $scope.EggFormsHelper = EggFormsHelper;
        $scope.EggOrderConst = EggOrderConst;
        $scope.settings = ModuleSettings.get({module: "egg-order"});

        if (data.id !== null) {
            EggOrder.get({id: data.id}).$promise.then(() => $scope.item = data);
        }

        $scope.isItemInProgress = item => item.quantityLeft !== item.stockQuantity;

        $scope.addItem = () => $scope.item.items.push({quantity: 0});

        $scope.refreshProducts = q => {
            if (!$scope.productsLoading) {
                $scope.productsLoading = true;
                Product.autocomplete(q).then(items => {
                    $scope.products = items;
                    $scope.productsLoading = false;
                });
            }
        };

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.save = () => {
            $scope.isSaving = true;
            let toSave = angular.copy($scope.item);
            toSave.items = toSave.items.filter(e => !$scope.isItemInProgress(e));
            if ($scope.item.id !== null) {
                EggOrder.updateNotStarted(toSave, onSaveSuccess, onSaveError);
            }
        };

        var onSaveSuccess = result => {
            $rootScope.$broadcast('egg.order.updated');
            $uibModalInstance.close(result);
            $scope.isSaving = false;
            toastr.success("Zapisano");
        };

        var onSaveError = () => $scope.isSaving = false;

        Unit.list().$promise.then(items => $scope.units = items);

        $scope.onProductChanged = (product, item) => {
            if (angular.isDefined(product)) {
                if (product.unit)
                    item.unit = product.defaultUnit;
                if (product.symbol)
                    item.product.productSymbol = product.symbol;
                if (product.name)
                    item.product.productName = $filter('localized')(product.name);

                Product.unitConverters({id: product.id}).$promise.then(unitConverters => item.product.systemProduct.unitConverters = unitConverters);
            } else
                delete item.unit;

        };
    })
    .controller('EggOrderSettingsController', function ($scope, toastr, $uibModalInstance, ModuleSettings, data, Client, Product, uiSelectFix, EggOrderConst) {
        $scope.item = data.item;
        $scope.uiSelectFix = uiSelectFix;
        $scope.EggOrderConst = EggOrderConst;

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.save = item => {
            $scope.isSaving = true;
            return ModuleSettings.save({module: "egg-order"}, item, saved => {
                $scope.isSaving = false;
                toastr.success("Zapisano ustawienia");
                $uibModalInstance.close(saved);
            }, () => {
                $scope.isSaving = false;
            });
        };

        $scope.refreshClients = q => {
            if (!$scope.clientsLoading) {
                $scope.clientsLoading = true;
                Client.autocomplete({q: q}).$promise.then(items => {
                    $scope.clients = items;
                    $scope.clientsLoading = false;
                });
            }
        };

        $scope.refreshProducts = q => {
            if (!$scope.productsLoading) {
                $scope.productsLoading = true;
                Product.autocomplete(q).then(items => {
                    $scope.products = items;
                    $scope.productsLoading = false;
                });
            }
        };
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_MODULE_EGG_ORDER",
            path: "/egg-order",
            ico: "fa fa-fw fa-cubes",
            name: 'egg.order.menu',
            order: 82
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('eggOrderList', {
            parent: 'app',
            url: '/egg-order?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{client:int}',
            data: {
                authorities: ['ROLE_MODULE_EGG_ORDER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/egg/order/list.tpl.html',
                    controller: 'EggOrderListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                page: (EggOrder, $stateParams) => EggOrder.table(angular.copy($stateParams)).$promise
            }
        });
    });
